import React from 'react';

import { ProgressBarContainer, ProgressBarFill } from './PSXProgressBar.styled';

interface PSXProgressBarProps {
  progress: number; // Progress value between 0 and 100
  fillColor: string; // Color of the progress bar fill
  ariaHidden?: boolean;
}

export const PSXProgressBar: React.FC<PSXProgressBarProps> = ({
  progress,
  fillColor,
  ariaHidden = false,
}) => (
  <ProgressBarContainer aria-hidden={ariaHidden}>
    <ProgressBarFill cssProps={{ progress, fillColor }} />
  </ProgressBarContainer>
);
